module.exports = __webpack_public_path__ + "static/forecast-poster-90b818481d844eb0beb0124efdf8899e.jpg";